import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "mega-header" }
const _hoisted_3 = { class: "mega-header-title" }
const _hoisted_4 = { class: "mega-body" }
const _hoisted_5 = {
  class: "mega-left",
  id: "mega-left"
}
const _hoisted_6 = ["onMouseenter", "onClick"]
const _hoisted_7 = {
  key: 0,
  class: "mega-right",
  id: "mega-right"
}
const _hoisted_8 = { class: "mega-cat-panel" }
const _hoisted_9 = { class: "mega-cat-title" }
const _hoisted_10 = {
  key: 0,
  class: "mega-cat-cols"
}
const _hoisted_11 = {
  key: 0,
  class: "mega-cat-col-title"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "mega-cat-col"
}
const _hoisted_14 = ["onClick"]

import { computed, ref, watch } from 'vue';
import type { MenuNode } from '@/models/entities/menu-node';

interface Props {
  menuData: MenuNode;
  isOpen?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WCMultiColumnMenu',
  props: {
    menuData: {},
    isOpen: { type: Boolean, default: false }
  },
  emits: ["selectSubcategory", "viewAll", "visitHome", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const activeIndex = ref(0);

const activeDept = computed(() => props.menuData.children?.[activeIndex.value] ?? null);

const nestedChildren = computed(
  () => activeDept.value?.children?.filter(child => child?.children?.length > 0) ?? [],
);

const singleChildren = computed(
  () => activeDept.value?.children?.filter(child => child && !child.children?.length) ?? [],
);

const hasCategories = computed(
  () => nestedChildren.value.length > 0 || singleChildren.value.length > 0,
);

const rightPanelVisible = computed(() => Boolean(activeDept.value));

function onMenuItemClick(dept: MenuNode): void {
  if (!dept.children || !dept.children.length) {
    emit('selectSubcategory', { parent: null, child: dept });
  }
}

function onSubcategoryClick(group: MenuNode | null, child: MenuNode): void {
  emit('selectSubcategory', { parent: group, child });
}

function onViewAll(dept: MenuNode): void {
  emit('viewAll', dept);
}

function onVisitHome(): void {
  emit('visitHome', props.menuData);
}

watch(
  () => props.menuData,
  () => {
    activeIndex.value = 0;
  },
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["desktop-dept-mega", { open: _ctx.isOpen }]),
    id: "dept-dropdown",
    "aria-label": _ctx.$t('departmentMenu', { name: _ctx.menuData.name }),
    onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('close')), ["esc"]))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.menuData.name), 1),
      _cache[2] || (_cache[2] = _createTextVNode()),
      _createElementVNode("button", {
        type: "button",
        class: "mega-header-link",
        onClick: onVisitHome
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "house" }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('visitDepartmentHome', { name: _ctx.menuData.name })), 1)
      ])
    ]),
    _cache[8] || (_cache[8] = _createTextVNode()),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuData.children, (dept, idx) => {
          return (_openBlock(), _createElementBlock("button", {
            key: dept.id,
            type: "button",
            class: _normalizeClass(["mega-dept", { 'is-active': activeIndex.value === idx }]),
            onMouseenter: ($event: any) => (activeIndex.value = idx),
            onClick: ($event: any) => (onMenuItemClick(dept))
          }, _toDisplayString(dept.name), 43, _hoisted_6))
        }), 128))
      ]),
      _cache[7] || (_cache[7] = _createTextVNode()),
      (rightPanelVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h3", _hoisted_9, [
                _createTextVNode(_toDisplayString(_ctx.$t('browse')) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(activeDept.value.name), 1)
              ]),
              _cache[5] || (_cache[5] = _createTextVNode()),
              (hasCategories.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nestedChildren.value, (group) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: group.id,
                        class: "mega-cat-col"
                      }, [
                        (group.name)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_11, _toDisplayString(group.name), 1))
                          : _createCommentVNode("", true),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, (child) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: child.id,
                            type: "button",
                            class: "mega-cat-link",
                            onClick: ($event: any) => (onSubcategoryClick(group, child))
                          }, _toDisplayString(child.name), 9, _hoisted_12))
                        }), 128))
                      ]))
                    }), 128)),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    (singleChildren.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singleChildren.value, (child) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: child.id,
                              type: "button",
                              class: "mega-cat-link",
                              onClick: ($event: any) => (onSubcategoryClick(null, child))
                            }, _toDisplayString(child.name), 9, _hoisted_14))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _cache[6] || (_cache[6] = _createTextVNode()),
              _createElementVNode("button", {
                type: "button",
                class: "mega-view-all",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onViewAll(activeDept.value)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('viewAllDepartment', { name: activeDept.value.name })) + " ", 1),
                _createVNode(_component_font_awesome_icon, { icon: "arrow-right" })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 42, _hoisted_1))
}
}

})